<template>
  <div class="min-h-screen bg-white relative flex flex-col">
    <GradientHalo />

    <!-- Header -->
    <header class="relative flex items-center justify-between px-6 md:px-10 pt-6 md:pt-8">
      <div class="flex items-center gap-3">
        <img class="h-8 w-auto" src="@/assets/large_logo_estaly_black.png" alt="Estaly" />
        <span
          class="inline-flex items-center rounded-full bg-primary-light text-primary-dark text-xs font-semibold px-3 py-1"
        >
          {{ t("client_space") }}
        </span>
      </div>
    </header>

    <!-- Main -->
    <main class="relative flex-1 flex items-center justify-center px-4 py-8 md:py-0">
      <ModernCard>
        <h1 class="text-2xl font-bold text-gray-900 leading-tight">{{ t("title") }}</h1>
        <p class="mt-2 text-sm text-gray-500 leading-relaxed">{{ t("subtitle") }}</p>

        <VeeForm v-slot="{ handleSubmit }" :validation-schema="schema" as="div" class="mt-8">
          <form @submit="handleSubmit($event, handleResetPassword)" novalidate>
            <ModernFormField
              id="email-address"
              name="email"
              type="email"
              autocomplete="email"
              v-model="email"
              :label="t('email_label')"
              :placeholder="t('email_placeholder')"
            />

            <ModernButton :loading="isLoading">
              {{ t("submit") }}
            </ModernButton>
          </form>
        </VeeForm>

        <div class="mt-6 text-center">
          <router-link to="/signin" class="text-sm text-gray-500 underline hover:text-gray-900 transition-colors">
            {{ t("back_to_signin") }}
          </router-link>
        </div>
      </ModernCard>
    </main>

    <!-- Footer -->
    <footer class="relative text-center py-6 text-sm text-gray-400">
      {{ t("need_help") }}
      <a href="mailto:contact@estaly.co" class="text-gray-500 underline hover:text-gray-900 transition-colors">
        {{ t("contact_us") }}
      </a>
    </footer>
  </div>
</template>

<script>
import { Form as VeeForm } from "vee-validate";
import * as yup from "yup";
import { mapActions, mapState } from "vuex";
import { useI18n } from "vue-i18n";
import { ModernButton, ModernFormField, ModernCard, GradientHalo } from "@estaly/ui";

export default {
  components: {
    VeeForm,
    ModernButton,
    ModernFormField,
    ModernCard,
    GradientHalo,
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return {
      email: "",
      isLoading: false,
    };
  },

  computed: {
    ...mapState("auth", ["signedIn"]),
    schema() {
      return yup.object({
        email: yup.string().required(this.t("email_required")).email(this.t("email_invalid")),
      });
    },
  },

  created() {
    if (this.signedIn) this.$router.push("/products");
  },

  methods: {
    ...mapActions("auth", ["forgotPassword"]),
    ...mapActions("notifications", ["notify"]),

    async handleResetPassword() {
      if (this.isLoading) return;
      this.isLoading = true;

      const response = await this.forgotPassword(this.email);
      this.isLoading = false;
      if (!response?.success) return;

      this.notify({
        type: "success",
        category: "simple",
        title: this.t("notify_title"),
        text: this.t("notify_text"),
      });
    },
  },
};
</script>

<i18n src="./ForgotPassword.i18n.json"></i18n>
